/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useState } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { formatAddress, titleCase } from 'blb-utils/format';
import { LinkButton } from '@blend/enterprise-components';
import { BlendBridge } from 'blb-types/blendBridge';
import { AddressModal } from '../AddressModal/AddressModal';

import { cardWrapperStyles, SectionCard } from '../DashboardPage/SectionCard';

export const styles = StyleSheet.create({
  headerContainer: {
    marginBottom: 16,
  },
  sectionContentContainer: {
    marginBottom: 48,
  },
});

export namespace AddressCard {
  export interface Props {
    address: BlendBridge.API.Address;
    fetchUserInfo: () => Promise<void>;
    readonly: boolean;
  }
}

export const AddressCard: React.FC<AddressCard.Props> = ({ address, fetchUserInfo, readonly }) => {
  const [isOpen, setModalOpen] = useState(false);
  return (
    <div className={css(cardWrapperStyles.singleCardWrapper)} key={address.lineText}>
      <SectionCard
        header={titleCase(address.type) + (address.isDefault ? ' (default)' : '')}
        id={`it-AddressCard-${address.lineText}`}
        sectionActions={
          !readonly && (
            <LinkButton
              icon="edit"
              id={`it-AddressCard-${address.lineText}-editButton`}
              label="Edit"
              onClick={() => setModalOpen(true)}
            />
          )
        }
        subtitle={formatAddress(address)}
      />
      <AddressModal
        address={address}
        fetchUserInfo={fetchUserInfo}
        handleClose={() => setModalOpen(false)}
        headerText="Edit Address"
        isOpen={isOpen}
      />
    </div>
  );
};
